'use client'
import { useState } from 'react'

export function CopyHexButton({ name, hex }: { name: string; hex: string }) {
  const [copied, setCopied] = useState(false)
  async function copy() {
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(hex)
      else {
        const ta = document.createElement('textarea')
        ta.value = hex; ta.style.position = 'fixed'; ta.style.opacity = '0'
        document.body.appendChild(ta); ta.select(); document.execCommand('copy'); ta.remove()
      }
      setCopied(true); setTimeout(() => setCopied(false), 1400)
    } catch { /* clipboard blocked — no false "Copied" */ }
  }
  return (
    <button type="button" onClick={copy} aria-label={`Copy ${name} hex ${hex}`}
      className="font-mono text-xs inline-flex items-center gap-2 border rounded px-2 py-1 border-[var(--color-border)]">
      {hex}
      <span aria-live="polite" className="sr-only">{copied ? `Copied ${hex}` : ''}</span>
      <span aria-hidden>{copied ? '✓' : '⧉'}</span>
    </button>
  )
}
